export const redirectToInbox = (staffId, history, isManagerInspecting) => {
  isManagerInspecting
    ? history.push(`/quality_control/manage/assign/${staffId}/inbox`)
    : history.push(`/quality_control/inbox`)
}
